<mat-spinner strokeWidth="3" [diameter]="50" *ngIf="loading"></mat-spinner>
<div fxFlex fxLayout="column" class="content-wrap">
  <!-- Toolbar -->
  <mat-toolbar>
    <button mat-button class="back-button" color="primary" routerLink="./../time-allocation">
      <mat-icon class="icon-chevron-left"></mat-icon>
      <span fxHide.gt-sm>Allocation</span>
    </button>

    <div fxFlex>
      <h2 class="title">Allocation History</h2>
    </div>
  </mat-toolbar>

  <!-- Content -->
  <div fxFlex class="allocation-history-content">
    <div *ngIf="dataSource.length > 0 && !loading">
      <table mat-table [dataSource]="timeAllocationHistory" multiTemplateDataRows>
        <ng-container matColumnDef="serviceDate">
          <th mat-header-cell *matHeaderCellDef>Service Date</th>
          <td mat-cell *matCellDef="let d">{{d.serviceDate | date: 'MM/dd/yyyy'}}</td>
        </ng-container>

        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef>Facility</th>
          <td mat-cell *matCellDef="let d">{{d.locationShortName}}</td>
        </ng-container>

        <ng-container matColumnDef="hoursWorked">
          <th mat-header-cell *matHeaderCellDef>Work Hrs.</th>
          <td mat-cell *matCellDef="let d">{{d.hoursWorked}}</td>
        </ng-container>

        <ng-container matColumnDef="hoursTraveled">
          <th mat-header-cell *matHeaderCellDef>Travel Hrs.</th>
          <td mat-cell *matCellDef="let d">{{d.hoursTraveled ?? 0}}</td>
        </ng-container>

        <ng-container matColumnDef="service">
          <th mat-header-cell *matHeaderCellDef>Service</th>
          <td mat-cell *matCellDef="let d">{{d.serviceDescription}}</td>
        </ng-container>

        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef>Role</th>
          <td mat-cell *matCellDef="let d">{{d.roleDescription ?? 'N/A'}}</td>
        </ng-container>

        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let d">
            <button mat-icon-button class="expand-allocation-button" [class.expand-allocation-button-toggled]="isExpanded(d)">
              <mat-icon class="icon-chevron-down"></mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let d" [attr.colspan]="displayedColumns.length">
            <div class="allocation-detail-wrapper" [class.allocation-detail-wrapper-expanded]="isExpanded(d)">
              <div class="allocation-detail">
                <p>{{d.allocationNote}}</p>
                <button mat-raised-button color="primary" (click)="editAllocation(d)">Edit</button>
                <button mat-raised-button color="accent" (click)="deleteAllocation(d)">Delete</button>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        class="allocation-entry-row"
        [class.expanded-note]="expandedAllocation === row"
        (click)="expandedAllocation = expandedAllocation === row ? null : row">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-note-row"></tr>
      </table>
    </div>
    <div *ngIf="dataSource.length === 0 && !loading">
      No Time Allocation History
    </div>
  </div>
</div>